import { Link } from "react-router-dom";
import { Button } from "components/common";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { assignUserRole } from "redux/authorization/userSlice";
import { useDispatch } from "react-redux";
import React, { useEffect, useState, useMemo } from "react";
import RoleForm from "components/app/authorization/role/RoleForm";
import { FaUserShield } from "react-icons/fa";
import { getRolesbyUser } from "redux/authorization/userSlice";
import { useSelector } from "react-redux";
import Select from 'react-select';
import { selectIconComponents, reactSelectCompactStyles } from 'helpers/reactSelectIconControl';
import PropTypes from 'prop-types';

// Stable reference — must NOT be re-created per render or react-select remounts
// its Control/Option and the menu/focus breaks.
const ROLE_SELECT_COMPONENTS = selectIconComponents(<FaUserShield size={14} className="tw-text-blue-500" />);

const AssignRole = ({userId, data=[]}) => {
  const { handleSubmit, setValue } = useForm();
  const dispatch = useDispatch();
  const [showNewRoleForm, setShowNewRoleForm] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);

  const {rolesByUserData} = useSelector(state => state.authorization_user);

  useEffect(() => {
    dispatch(getRolesbyUser({user_id: userId}));
  }, [dispatch, userId, data]);


  useEffect(() => {
    const selected = data.length > 0 && data.map(item => ({value: item.id, label: item.name}));
    setSelectedRoles(selected);
  }, [userId, data])

  const onSubmit = (data) => {

    try {
      if (userId) {
        dispatch(assignUserRole({userId, data}))
      }
    }
    catch (error) {
      toast.error(error.message)
    }
  }

  const rolesOptions = rolesByUserData && rolesByUserData.map(item => ({value: item.id, label: item.name}));

  const defaultRolesOption = useMemo(() => {
    if (data) {
      return data.map((item) => ({value: item.id, label: item.name}));
    }
    return null;
  }, [data]);

  const handleChangeRole = (selectedOptions) => {
    const selectedOptionsValues = selectedOptions.map((option) => option.value);
    setValue('role_ids', selectedOptionsValues, { shouldValidate: true })
    setSelectedRoles(selectedOptions)
  }

  const handleNewRole = (e) => {
    e.preventDefault();
    setShowNewRoleForm(true)
  }

  return (
    <>
      <div className="tw-mb-2">Assigning roles access to the system</div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="tw-mb-2 tw-text-sm">
          <Select
            components={ROLE_SELECT_COMPONENTS}
            styles={reactSelectCompactStyles}
            closeMenuOnSelect={false}
            options={rolesOptions}
            defaultValue={defaultRolesOption}
            value={selectedRoles}
            placeholder='Select...'
            classNamePrefix='react-select'
            isMulti
            onChange={handleChangeRole}
          />
        </div>

        <div className="tw-flex tw-justify-between tw-items-center">
          <div>Total {data?.length} roles assigned.</div>
          <Button
            type="submit"
            size="sm"
            variant="secondary"
          >
            <span><FaUserShield className="tw-mr-1" /> {data.length > 0 ? "Update" : "Add"} Role</span>
          </Button>
        </div>
      </form>

      <div className="tw-mt-4 tw-flex tw-justify-end">
        <Link onClick={(e) => handleNewRole(e)}>Create new Role</Link>
      </div>

      {showNewRoleForm && (
        <RoleForm
          showModal={showNewRoleForm}
          setshowModal={setShowNewRoleForm}
          title="Create a new Role"
        />
      )}
    </>
  )
};

AssignRole.propTypes = {
  userId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired
}

export default AssignRole;